import defiLogo from "../../assets/defi-logo.png";
import "./Header.css";
import { Bars3Icon } from "@heroicons/react/24/solid";
import React, { useState } from "react";

function Header() {
  const [toggle, setToggle] = useState(false);

  return (
    <header className="navbar">
      <img src={defiLogo} alt="DefiPe" className="logo" />
      <nav className="desktop-menu">
        <ul id="menuList">
          <li>
            <a href="https://homedefi.netlify.app/">Home</a>
          </li>
          <li>
            <a href="https://defipe.netlify.app/">Trade</a>
          </li>
          <li>
            <a href="">Buy Crypto</a>
          </li>
        </ul>
      </nav>
      {toggle ? (
        <nav className="mobile-menu">
          <ul id="menuList">
            <li>
            <a href="https://homedefi.netlify.app/">Home</a>
            </li>
            <li>
            <a href="https://defipe.netlify.app/">Trade</a>
            </li>
            <li>
            <a href="">Buy Crypto</a>
            </li>
          </ul>
        </nav>
      ) : (
        <></>
      )}
      <Bars3Icon className="menu-icon" onClick={() => setToggle(!toggle)} />
     
    </header>
  );
}

export default Header;
